import { useEffect, useState } from 'react'
import { Image } from 'expo-image'
import { getAvatarFromCache, setAvatarInCache } from '../../utils/ttlCache'
import { avatarPlaceholder } from '../customUtils/Constants'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'
import { Platform } from 'react-native'
import { downloadAvatarUser, getAvatarUser } from '@/utils/functions.utils'

let UserServices = null
if (Platform && Platform.OS !== 'web') {
    try {
        // static relative require so webpack can analyze the dependency
        // eslint-disable-next-line global-require
        UserServices = require('../../../database/user.database').UserServices
    } catch (e) {
        console.warn('Could not load UserServices (probably web build):', e)
    }
}

export const UserAvatarWeb = ({ avatarUrl, style }) => {
    const __UserAvatarCache = new Map()
    const [avatar, setAvatar] = useState(avatarPlaceholder)

    useEffect(() => {
        let mounted = true
        const key = avatarUrl

        if (!key) {
            setAvatar(avatarPlaceholder)
            return
        }

        // Si ya es una URL completa (empieza con http), usarla directamente
        const isFullUrl = key.startsWith('http://') || key.startsWith('https://')

        if (isFullUrl) {
            setAvatar(key)
            return
        }

        // Si no es URL completa, es un filename de S3, procesar normalmente
        const hit = __UserAvatarCache.get(key)

        if (hit) {
            setAvatar(hit)
            return
        }

        // 1) TTL cache persistente
        getAvatarFromCache(key)
            .then((cached) => {
                if (!mounted) return
                if (cached) {
                    setAvatar(cached)
                    return true
                }
                return false
            })
            .then((servedFromCache) => {
                if (servedFromCache) return
                // 2) Resolver filename a URL desde S3
                getImageStogeUrl(key).then(async (url) => {
                    if (!mounted) return
                    if (url) {
                        setAvatar(url)
                        try {
                            await setAvatarInCache(key, url)
                        } catch (e) {}
                    }
                })
            })

        return () => {
            mounted = false
        }
    }, [avatarUrl])

    return <Image style={style} source={{ uri: avatar }} />
}

export const UserAvatarMobile = ({ style, contentFit = 'cover' }) => {
    const [avatar, setAvatar] = useState(avatarPlaceholder)
    const getAndSetAvatarUser = async () => {
        const user = await UserServices.getUser()
        if (!user || !user.avatar) {
            return
        }
        const url = await getAvatarUser(user.avatar)
        if (url && url !== null && url !== undefined && url !== '') {
            setAvatar(url)
        } else {
            const url = await getImageStogeUrl(user.avatar)
            if (url && url !== null && url !== undefined && url !== '') {
                setAvatar(url)
                downloadAvatarUser(url, user.avatar)
            }
        }
    }
    useEffect(() => {
        getAndSetAvatarUser()
    }, [])

    return <Image style={style} source={{ uri: avatar }} contentFit={contentFit} />
}
